import { T } from './actionTypes';
import type { CmsContentState } from './types';

export const cacheContent = <T>(key: keyof CmsContentState, data: T) => ({
  type: T.CACHE_CONTENT,
  payload: { key, data }
});
